import { GROUPS } from '@/service/apiConf';

// 公共接口依赖由各业务权限的 relative.onCheck/onUnCheck 显式维护，不再为所有角色强制授权。
export const GLOBAL_AUTH = {};

// 系统角色仅保存用户选择的权限，不自动补回大屏查看权限。
export const SYSTEM_AUTH = {};

// 默认数据中心权限
export const DC_AUTH = {};

// 默认租户权限
export const TENANT_AUTH = {
  [GROUPS.notice]: {
    watch: { list: true },
    notices: { list: true },
  },
  [GROUPS.ophub]: {
    ['system-config']: { list: true },
    ['system-configs']: { list: true },
    ['recharge-requests']: { create: true },
    ['s3-credentials']: { list: true },
  },
};
